import fetchFactory from '../../../utils/fetchFactory'
import {configEnum} from '../../../enums/fetchFactoryEnum'

export const acceptCGU = (portal: string) => fetchFactory(`/api/${portal}/utilisateur/acceptCgu`,
    {
        method: configEnum.post,
    })